<template>
    <svg fill="#9BA2B6" height="25" viewBox="0 0 27 25" width="27" xmlns="http://www.w3.org/2000/svg">
        <g fill-rule="nonzero">
            <circle cx="8.55" cy="4.05" r="4.05" />
            <path
                d="M15.3 8.707a5.255 5.255 0 0 0-2.031-1.227l-.894-.28-3.833 4.104L4.704 7.2l-.894.28C1.533 8.217 0 10.417 0 12.963V18h11.914c-.656-2.839.04-5.966 2.108-8.18A8.257 8.257 0 0 1 15.3 8.707z"
            />
            <path
                d="M24.893 12.778c-1.36-1.276-3.169-1.978-5.093-1.978s-3.733.702-5.094 1.978c-2.808 2.632-2.808 6.915 0 9.548 1.405 1.316 3.25 1.974 5.094 1.974 1.845 0 3.69-.658 5.093-1.974 2.81-2.633 2.81-6.916 0-9.548zM13.75 17.552c0-1.515.63-2.94 1.772-4.01 1.143-1.072 2.663-1.662 4.279-1.662 1.423 0 2.77.458 3.851 1.298l-8.517 7.984a5.417 5.417 0 0 1-1.385-3.61zm10.33 4.01c-2.221 2.082-5.754 2.202-8.13.363l8.517-7.983a5.417 5.417 0 0 1 1.385 3.61c0 1.515-.63 2.939-1.772 4.01z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "UserSlash",
};
</script>
